import { mediaApi } from '../../api/media';

export const readVideoDuration = (file) => new Promise((resolve, reject) => {
  const video = document.createElement('video');
  const url = URL.createObjectURL(file);
  const cleanup = () => {
    clearTimeout(timer);
    video.onloadedmetadata = null;
    video.onerror = null;
    video.removeAttribute('src');
    URL.revokeObjectURL(url);
  };
  const fail = () => { cleanup(); reject(new Error('تعذر قراءة الفيديو. جرّب ملف MP4 أو WebM أو MOV.')); };
  const timer = setTimeout(fail, 15000);
  video.preload = 'metadata';
  video.onloadedmetadata = () => {
    const duration = video.duration;
    if (!Number.isFinite(duration) || duration <= 0) { fail(); return; }
    cleanup();
    resolve(duration);
  };
  video.onerror = fail;
  video.src = url;
});

export async function uploadChatVideo(file, onStatus, signal) {
  const duration = await readVideoDuration(file);
  if (signal?.aborted) throw new DOMException('Cancelled', 'AbortError');
  const job = await mediaApi.uploadVideo(file, duration, onStatus, { signal });
  if (signal?.aborted) throw new DOMException('Cancelled', 'AbortError');
  if (job.status !== 'READY' || !job.publicUrl) throw new Error('الفيديو غير جاهز للإرسال. أعد المحاولة.');
  // Only the voice-isolated output is attached, never the original upload.
  return { type: 'VIDEO', url: job.publicUrl, contentType: 'video/mp4', altText: '', fileName: file.name.replace(/\.[^.]+$/, '') + '.mp4' };
}
